const UPLOAD_STARTED = "uploadStarted";
const UPLOAD_FINISHED = "uploadFinished";
const UPLOAD_ERRORED = "uploadErrored";
const PROCESSING_STARTED = "processingStarted";
const PROCESSING_FINISHED = "processingFinished";
const PHOTO_UPLOADED = "photoUploaded";
const UPLOADED_ARTWORK = "uploadedArtwork";
const QR_UPLOAD_INITIATED = "qrUploadInitiated";
const QR_UPLOAD_COMPLETED = "qrUploadCompleted";
const QR_CODE_GENERATED = "qrCodeGenerated";
const QR_CODE_EXPIRED = "qrCodeExpired";
const UPLOAD_MODAL_OPENED = "uploadModalOpened";
const UPLOAD_MODAL_CLOSED = "uploadModalClosed";
const MAT_OPTIONS_OPENED = "matOptionsOpened";
const MAT_OPTION_SELECTED = "matOptionSelected";
const MAT_COLOR_TEXTURE_OPENED = "matColorTextureOpened";
const MAT_COLOR_TEXTURE_CATEGORY_SELECTED = "matColorTextureCategorySelected";
const MAT_COLOR_TEXTURE_SUBCATEGORY_SELECTED = "matColorTextureSubCategorySelected";
const MAT_STYLE_SELECTED = "matStyleSelected";
const ACCENT_MAT_ADDED = "accentMatAdded";
const ACCENT_MAT_CATEGORY_SELECTED = "accentMatCategorySelected";
const ACCENT_MAT_STYLE_SELECTED = "accentMatStyleSelected";
const MAT_WIDTH_OPENED = "matWidthOpened";
const MAT_WIDTH_SELECTED = "matWidthSelected";
const ENTERED_FRAMING_FLOW = "enteredFramingFlow";

export const EVENTS = {
  UPLOAD_STARTED,
  UPLOAD_FINISHED,
  UPLOAD_ERRORED,
  PROCESSING_STARTED,
  PROCESSING_FINISHED,
  PHOTO_UPLOADED,
  UPLOADED_ARTWORK,
  QR_UPLOAD_INITIATED,
  QR_UPLOAD_COMPLETED,
  QR_CODE_GENERATED,
  QR_CODE_EXPIRED,
  UPLOAD_MODAL_OPENED,
  UPLOAD_MODAL_CLOSED,
  MAT_OPTIONS_OPENED,
  MAT_OPTION_SELECTED,
  MAT_COLOR_TEXTURE_OPENED,
  MAT_COLOR_TEXTURE_CATEGORY_SELECTED,
  MAT_COLOR_TEXTURE_SUBCATEGORY_SELECTED,
  MAT_STYLE_SELECTED,
  ACCENT_MAT_ADDED,
  ACCENT_MAT_CATEGORY_SELECTED,
  ACCENT_MAT_STYLE_SELECTED,
  MAT_WIDTH_OPENED,
  MAT_WIDTH_SELECTED,
  ENTERED_FRAMING_FLOW
};

export function getDataLayer() {
  window.dataLayer = window.dataLayer || [];
  return window.dataLayer;
}

export function dataLayerHasEmployeeFlag() {
  const dataLayer = getDataLayer();
  return Boolean(dataLayer?.find(data => data.employee));
}

function addEventToDataLayer(values) {
  const dataLayer = getDataLayer();
  if (Object.keys(values).length > 0 && !dataLayerHasEmployeeFlag()) {
    return dataLayer.push(values);
  } else {
    // eslint-disable-next-line
    console.log("employee flagged action: ", values);
  }
}

export function add(values = {}) {
  if (Array.isArray(values)) {
    values.forEach(item => addEventToDataLayer(item));
  } else {
    addEventToDataLayer(values);
  }
}

export function addInternalEvent(values = {}) {
  const dataLayer = getDataLayer();

  if (Object.keys(values).length > 0) {
    return dataLayer.push(values);
  }
}

const ENTERED_FRAMING_FLOW_DEDUPE_KEY = "enteredFramingFlowFiredAt";
const ENTERED_FRAMING_FLOW_DEDUPE_WINDOW_MS = 20000;

// Called by the shopify-theme WAYF/physical-art pages on load. Each visit is its own
// distinct funnel entry, so this always fires -- it also stamps the dedupe key so a
// subsequent hard navigation into the veneer-vite SPA for the same visit doesn't double-fire.
export function addFramingFlowEntry(pagePath) {
  window.sessionStorage?.setItem(ENTERED_FRAMING_FLOW_DEDUPE_KEY, String(Date.now()));
  add({ event: EVENTS.ENTERED_FRAMING_FLOW, pagePath });
}

// Called by veneer-vite's router guard on a fresh page load, which may be a direct
// continuation of a theme WAYF/physical-art page visit in the same tab (shared
// sessionStorage, same origin). No-ops if a theme page already fired in the last 20s.
export function addFramingFlowEntryNotRecentlyFired(pagePath) {
  const lastFiredAt = Number(window.sessionStorage?.getItem(ENTERED_FRAMING_FLOW_DEDUPE_KEY));

  if (lastFiredAt && Date.now() - lastFiredAt < ENTERED_FRAMING_FLOW_DEDUPE_WINDOW_MS) {
    return;
  }

  addFramingFlowEntry(pagePath);
}
